/* eslint-disable react-refresh/only-export-components -- This file exports a
   route MANIFEST, not components. Its screen is defined inside a factory so it
   can close over the API client, which puts it beyond Fast Refresh's reach
   whatever this file exports. */

/**
 * What feature-flag administration contributes to the route tree.
 *
 * One route, declaring the permission it needs — and the same declaration
 * drives both the router's gate and the navigation entry, so a menu item
 * cannot appear for a page the user would be refused.
 *
 * `settings.flag.read` rather than `settings.flag.manage`: somebody who may
 * see which capabilities are on, but not change them, gets the page with the
 * buttons absent. Read-only access to a screen is more useful than no access,
 * and the screen already treats the two permissions separately.
 */

import type { ApiClient } from "@hardauto/core-api";
import type { FeatureRoutes } from "@hardauto/core-router";

import { FlagsScreen } from "./screens/FlagsScreen";
import "./i18n";

export const SETTINGS_PATHS = {
  flags: "/admin/flags",
} as const;

export function settingsRoutes(client: ApiClient): FeatureRoutes {
  function Flags() {
    return <FlagsScreen client={client} />;
  }

  return {
    id: "settings",
    routes: [
      {
        path: SETTINGS_PATHS.flags,
        component: Flags,
        layout: "app",
        requirement: { authenticated: true, permissions: ["settings.flag.read"] },
        // 50, after audit at 40: administration reads roughly in order of how
        // often it is used, and flags are changed rarely.
        nav: { labelKey: "settings:nav.flags", section: "admin", order: 50 },
      },
    ],
  };
}
